import React from 'react';
import { BottomBox, DescriptionSuccess, ModalBox, TitleDiv, TitleSuccess } from '../styles';
import SVGIcon from '../../../../assets/images/svg/SVGIcon';
import IconButton from '../../../button/iconButton';
import { ICON_BUTTON_SIZE, ICON_BUTTON_TYPE } from '../../../../global/constants';

interface Props {
  onClose: () => void;
}

export const SuccessFullModal: React.FC<Props> = (props) => {
  const { onClose } = props;
  return (
    <>
      <ModalBox>
        <IconButton
          iconName='new-close-icon'
          size={ICON_BUTTON_SIZE.SMALL}
          variant={ICON_BUTTON_TYPE.TERTIARY}
          onClick={onClose}
          className='closeIcon'
        />
        <BottomBox>
          <SVGIcon
            name={'subscripton-successful-icon'}
            width='56'
            height='56'
            viewBox='0 0 56 56'
            fill='var(--neutral-secondary)'
          />
          <TitleDiv>
            <TitleSuccess>Message sent</TitleSuccess>
            <DescriptionSuccess>We’ll be touch with you soon over email.</DescriptionSuccess>
          </TitleDiv>
        </BottomBox>
      </ModalBox>
    </>
  );
};
